import { v4 } from "uuid";

import { getLocalStorageItem, setLocalStorageItem } from "@/browser/storage";

const UNREGISTERED_USER_SESSION_KEY = "X-Session";

export function setUnregisteredUserSessionId(id: string) {
  setLocalStorageItem(UNREGISTERED_USER_SESSION_KEY, id);
}

export function getUnregisteredUserSessionId(): string | undefined {
  return getLocalStorageItem(UNREGISTERED_USER_SESSION_KEY);
}

export function getOrCreateUnregisteredUserSessionId(): string {
  const sessionId = getUnregisteredUserSessionId();

  if (sessionId) {
    return sessionId;
  } else {
    const newSessionId = v4();

    setUnregisteredUserSessionId(newSessionId);

    return newSessionId;
  }
}
